import { Button, Input, Row, Typography, Select, message } from "antd";
import { ReactComponent as Logoo } from "./Svgs/Cohort.svg";
import React, { useState } from 'react'
import { createLabelApi } from "utils/apiService";
import { getAllLabelsData } from "actions/MultiLanguageActions";
import { useDispatch } from "react-redux";
const { Text } = Typography;

export default function AddLabelModalContent(props) {
    const { closeModal } = props;
    const [label, setLabel] = useState({
        name: "",
        path: "",
        // image_url: "",
    });
    const dispatch = useDispatch()

    const formValidation = (label) => {
        // const { address, city, country, region, latitude, longitude } = Label;
        // let isNumber = /[+-]?([0-9]*[.])?[0-9]+/;
        for (var key of Object.keys(label)) {
            if (label[key] == "" || !label[key]) {
                message.error(`${key} is required`);
                return false;
            }
        }
        return true;
    };

    const addLabel = async (label, loadTable) => {
        if (!formValidation(label)) {
            return;
        }
        createLabelApi({
            requestData: label,
            res200Callback: () => {
                message.success("Label Added successfully.");
                getAllLabelsData(dispatch)
                closeModal()
                // fetchLabelData()
                // setDisableModal(false);
                // toggleModal();
                // props.loadTable();
            },
            resErrorCallback: () => {
                message.error("Failed updating the Label !");
            },
        });
    };

    return (
        <div>
            <Row className="modal-row">
                <Row>
                    <div style={{ display: "flex" }}>
                        <div>
                            <Logoo style={{ marginTop: "2px" }} />
                        </div>
                        <Text
                            style={{
                                marginLeft: "16px",
                                fontWeight: "700",
                                color: "#181818",
                                fontSize: "24px",
                                fontStyle: "normal",
                                lineHeight: "40px",
                            }}>
                            Add a New Label
                        </Text>
                    </div>
                </Row>

                <div style={{ margin: "16px 0px", background: "#E8E8E8", height: "1px" }}></div>
                <Row className="stores_wrapper">
                    <div>
                        <div>
                            <div>
                                <Text
                                    style={{
                                        fontSize: "14px",
                                        color: "#181818",
                                        fontWeight: "bold",
                                    }}>
                                    Label
                                </Text>
                            </div>
                            <Input
                                className="time-value-cohort-col-main-element"
                                style={{ width: "100%", marginTop: "4px" }}
                                placeholder="Enter Label"
                                value={label.name}
                                onChange={(event) => {
                                    setLabel({
                                        ...label,
                                        ["name"]: event.target.value,
                                    });
                                }}
                                name="name"
                            />
                        </div>
                        <div
                            style={{
                                marginTop: "32px",
                            }}>
                            <Text
                                style={{
                                    fontSize: "14px",
                                    color: "#181818",
                                    fontWeight: "bold",
                                }}>
                                Path
                            </Text>
                            <Input
                                className="time-value-cohort-col-main-element"
                                style={{ width: "100%", marginTop: "4px" }}
                                placeholder="Enter Path"
                                value={label.path}
                                onChange={(event) => {
                                    setLabel({
                                        ...label,
                                        [event.target.name]: event.target.value,
                                    });
                                }}
                                name="path"
                            />
                        </div>
                        {/* <div
                            style={{
                                marginTop: "32px",
                                //   display: "flex",
                            }}>
                            <Text
                                style={{
                                    fontSize: "14px",
                                    color: "#181818",
                                    fontWeight: "bold",
                                    // fontWeight:"bold"
                                }}>
                                Path Images URL
                            </Text>
                            <Input
                                className="time-value-cohort-col-main-element"
                                style={{ width: "100%", marginTop: "4px" }}
                                placeholder="Enter path images url"
                                value={label.image_url}
                                onChange={(event) => {
                                    setLabel({
                                        ...label,
                                        [event.target.name]: event.target.value,
                                    });
                                }}
                                name="image_url"
                            />
                        </div> */}
                    </div>

                    <div
                        style={{
                            marginTop: "24px ",
                            background: "#E8E8E8",
                            height: "1px",
                        }}></div>
                    <Row
                        type="flex"
                        justify="end"
                        align="middle"
                        style={{
                            marginTop: "32px",
                        }}>
                        <Button
                            size="large"
                            style={{
                                height: "40px",
                                boxShadow: "none",
                                borderRadius: "20px",
                                border: "none",
                                backgroundColor: "#FFFFFF",
                                color: "#181818",
                                marginRight: "12px",
                            }}
                            onClick={() => {
                                closeModal()
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            size="large"
                            style={{
                                height: "40px",
                                borderRadius: "5px",
                                border: "none",
                                backgroundColor: "#fec708",
                                color: "#FFFFFF",
                            }}
                            onClick={() => {
                                addLabel(label);
                            }}>
                            Add Label
                        </Button>
                    </Row>
                </Row>
            </Row>
        </div>
    )
}
